<template>
    <v-card class="my-2 c-card" flat>
        <div class="card-header">
            <v-layout row align-center>
                <v-card-title class="card-title" :style="{ color : titleColor }">{{ title }} <span v-if="total" class="grey--text">&nbsp;({{total}})</span></v-card-title>
                <v-spacer></v-spacer>
                <v-btn class="fz-12 text-capitalize text-transform-none text-dark text-muted font-weight-regular" v-if="linkTitle" :ripple="false" small flat :to="route">
                    {{ linkTitle }}
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-layout>
        </div>
        <slot></slot>
    </v-card>
</template>

<script>
    export default {
        props:
        {
            title: String,
            total: String,
            titleColor: String,
            // linkTitle: String,
            route: String,
            linkTitle: {
                type: String,
                default : '',
            },
        }
    }
</script>

<style lang="scss">
@import "../scss/app.scss";

.c-card
{
    .card-header
    {
        width: 100%;
    }

    .card-title
    {
        font-size: 14px;
        font-weight: $bold;

        @media screen and (max-width: $mobile-xs)
        {
            font-size: 12px;
        }
    }
}
</style>
